import { en } from "./translations.en";
import { fr } from "./translations.fr";
import { pt } from "./translations.pt";

export const translations = {
  en: {
    profile: en,
  },
  fr: {
    profile: fr,
  },
  pt: {
    profile: pt,
  },
};
